import api from "./api";

/**
 * Institute dashboard — manage FAQs (scoped to institute; super admin may pass instituteId).
 * Paths: /api/v1/institute/faqs (registered on v1 + instituteRoutes for compatibility).
 */
export const instituteFaqService = {
  list: (params = {}) => api.get("/institute/faqs", { params }),
  getById: (id, params = {}) => api.get(`/institute/faqs/${id}`, { params }),
  create: (data) => api.post("/institute/faqs", data),
  update: (id, data) => api.put(`/institute/faqs/${id}`, data),
  bulkUpdate: (updates) => api.patch("/institute/faqs/bulk-update", { updates }),
  remove: (id, axiosConfig) => api.delete(`/institute/faqs/${id}`, axiosConfig),
};

/**
 * Mobile app — same API base; use token from mobile auth.
 * GET /mobile/help/faqs?search=&page=&limit=
 * GET /mobile/help/faqs/:id
 */
export const mobileHelpFaqService = {
  list: (params = {}) => api.get("/mobile/help/faqs", { params }),
  getById: (id) => api.get(`/mobile/help/faqs/${id}`),
};

export const webHelpService = {
  contactSupport: (body) => api.post("/web/help/contact-support", body),
};

export default instituteFaqService;
